import * as types from "./types";

const mutations = {
    [types.GET_EXPENSE_LIST](state, expenseList) {
        state.expenseList = expenseList;
    },
    [types.POST_EXPENSE](state, id) {
        state.expenseId = id;
    },
    [types.DELETE_EXPENSE](state, id) {
        state.expenseId = id;
    },
    [types.UPDATE_EXPENSE](state, id) {
        state.expenseId = id;
    },
    [types.LOADING_ITEM](state, loading) {
        state.loading = loading;
    }
};

export default mutations;